/* ==========================================================================
   NEKT — shared interactions: scroll reveal, count-up, header/cart drawer,
   hero hover, ritual step demo, pouch tilt, variant tabs, FAQ accordion.
   Cart state is the single source of truth (Shopify Ajax Cart API) — no
   client-side mock data, unlike the original design prototype.
   ========================================================================== */
(function () {
  'use strict';

  var fmt = function (cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  };

  /* ---------------- reveal on scroll ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          if (e.target.dataset.count && !e.target.dataset.nkCounted) {
            e.target.dataset.nkCounted = '1';
            countUp(e.target);
          }
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('is-visible')) el.classList.add('is-visible');
      });
    }, 4000);
  }

  function countUp(el) {
    var target = parseFloat(el.dataset.count) || 0;
    var pre = el.dataset.pre || '', post = el.dataset.post || '';
    var dur = 1100, t0 = Date.now();
    var iv = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + Math.round(target * e) + post;
      if (p >= 1) clearInterval(iv);
    }, 40);
    setTimeout(function () { clearInterval(iv); el.textContent = pre + target + post; }, dur + 260);
  }

  /* ---------------- scroll progress bar ---------------- */
  function initProgress() {
    var bar = document.querySelector('[data-nk-progress]');
    if (!bar) return;
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? Math.min(100, (window.scrollY / h) * 100) : 0) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- hero AM/PM hover grow ---------------- */
  function initHero() {
    var hero = document.querySelector('[data-nk-hero]');
    if (!hero) return;
    var am = hero.querySelector('[data-hero-panel="am"]');
    var pm = hero.querySelector('[data-hero-panel="pm"]');
    if (!am || !pm) return;
    var set = function (which) {
      am.style.flexGrow = which === 'am' ? '1.55' : which === 'pm' ? '0.65' : '1';
      pm.style.flexGrow = which === 'pm' ? '1.55' : which === 'am' ? '0.65' : '1';
    };
    am.addEventListener('mouseenter', function () { set('am'); });
    pm.addEventListener('mouseenter', function () { set('pm'); });
    hero.addEventListener('mouseleave', function () { set(null); });

    hero.addEventListener('mousemove', function (e) {
      var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
      var dx = (e.clientX - cx) / cx, dy = (e.clientY - cy) / cy;
      hero.querySelectorAll('[data-blob]').forEach(function (el) {
        var k = parseFloat(el.dataset.blob) || 0;
        el.style.transform = 'translate(' + (dx * k) + 'px,' + (dy * k * 0.7) + 'px)';
      });
    });
  }

  /* ---------------- ritual step demo (tear / squeeze / go) ---------------- */
  function initRitual() {
    var wrap = document.querySelector('[data-nk-ritual]');
    if (!wrap) return;
    var steps = wrap.querySelectorAll('[data-step-btn]');
    var art = wrap.querySelector('[data-ritual-art]');
    var idx = 0, hold = false, holdTimer, cycleTimer;

    function apply(n) {
      idx = n;
      steps.forEach(function (b, i) { b.classList.toggle('is-active', i === n); });
      if (art) art.setAttribute('data-active-step', n);
    }
    steps.forEach(function (b, i) {
      var go = function () {
        hold = true;
        clearTimeout(holdTimer);
        holdTimer = setTimeout(function () { hold = false; }, 6000);
        apply(i);
      };
      b.addEventListener('click', go);
      b.addEventListener('mouseenter', go);
    });
    apply(0);
    cycleTimer = setInterval(function () {
      if (hold) return;
      apply((idx + 1) % steps.length);
    }, 2800);
  }

  /* ---------------- pouch 3D tilt ---------------- */
  function initPouchTilt() {
    document.querySelectorAll('[data-pouch-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transition = 'transform .18s ease-out';
        el.style.transform = 'rotateY(' + (px * 20) + 'deg) rotateX(' + (-py * 12) + 'deg) translateY(' + (-Math.abs(px) * 4) + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform .7s cubic-bezier(.16,1,.3,1)';
        el.style.transform = 'none';
      });
    });
  }

  /* ---------------- variant tab picker (pouch section) ---------------- */
  function initVariantTabs() {
    document.querySelectorAll('[data-nk-variant-picker]').forEach(function (picker) {
      var tabs = picker.querySelectorAll('[data-variant-tab]');
      var panels = picker.querySelectorAll('[data-variant-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-variant-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-variant-panel') !== id;
          });
        });
      });
    });
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq() {
    document.querySelectorAll('.nk-faq__item').forEach(function (item) {
      var q = item.querySelector('.nk-faq__q');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        item.closest('.nk-faq').querySelectorAll('.nk-faq__item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  /* ---------------- toast ---------------- */
  var toastEl, toastTimer;
  function flash(msg) {
    if (!toastEl) toastEl = document.querySelector('[data-nk-toast]');
    if (!toastEl) return;
    toastEl.querySelector('[data-nk-toast-msg]').textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* ---------------- cart (Shopify Ajax Cart API) ---------------- */
  var Cart = {
    scrim: null,
    drawer: null,
    badge: null,

    init: function () {
      this.scrim = document.querySelector('[data-nk-cart-scrim]');
      this.drawer = document.querySelector('[data-nk-cart-drawer]');
      this.badge = document.querySelector('[data-nk-cart-badge]');
      var self = this;

      document.querySelectorAll('[data-nk-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });
      document.querySelectorAll('[data-nk-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-nk-add-form]');
        if (!form) return;
        e.preventDefault();
        self.add(form);
      });

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cart-inc], [data-cart-dec]');
        if (!btn) return;
        var key = btn.getAttribute('data-line-key');
        var delta = btn.hasAttribute('data-cart-inc') ? 1 : -1;
        self.changeByKey(key, delta);
      });

      this.refresh();
    },

    open: function () {
      if (this.scrim) this.scrim.classList.add('is-open');
      if (this.drawer) this.drawer.classList.add('is-open');
    },
    close: function () {
      if (this.scrim) this.scrim.classList.remove('is-open');
      if (this.drawer) this.drawer.classList.remove('is-open');
    },

    add: function (form) {
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status) { flash(item.description || 'Could not add that item.'); return; }
          flash((item.product_title || item.title) + ' added to cart');
          if (Cart.badge) {
            Cart.badge.style.animation = 'none';
            setTimeout(function () { Cart.badge.style.animation = ''; Cart.badge.classList.add('is-bump'); }, 16);
            setTimeout(function () { Cart.badge.classList.remove('is-bump'); }, 600);
          }
          Cart.refresh();
          Cart.open();
        })
        .catch(function () { flash('Something went wrong adding that.'); });
    },

    changeByKey: function (key, delta) {
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === key; });
        if (!line) return;
        var qty = Math.max(0, line.quantity + delta);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); }).then(function () { self.refresh(); });
      });
    },

    refresh: function () {
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); });
    },

    render: function (cart) {
      if (this.badge) this.badge.textContent = cart.item_count;

      var body = document.querySelector('[data-nk-cart-body]');
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<p class="nk-cart-drawer__empty">Nothing here yet. The Starter is twelve sachets — six mornings, six evenings.</p>';
        } else {
          body.innerHTML = cart.items.map(function (item) {
            return '' +
              '<div class="nk-cart-line">' +
                '<div class="nk-cart-line__info">' +
                  '<div class="nk-cart-line__name">' + item.product_title + '</div>' +
                  '<div class="nk-cart-line__sub">' + item.variant_title + '</div>' +
                  '<div class="nk-cart-line__qty">' +
                    '<button class="nk-qty-btn" data-cart-dec data-line-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
                    '<span>' + item.quantity + '</span>' +
                    '<button class="nk-qty-btn" data-cart-inc data-line-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
                  '</div>' +
                '</div>' +
                '<div class="nk-cart-line__total">' + fmt(item.final_line_price) + '</div>' +
              '</div>';
          }).join('');
        }
      }

      var subtotalEl = document.querySelector('[data-nk-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = fmt(cart.items_subtotal_price);

      var discountRows = document.querySelector('[data-nk-cart-discounts]');
      if (discountRows) {
        var lines = (cart.cart_level_discount_applications || []).concat(
          cart.items.flatMap(function (i) { return i.line_level_discount_allocations || []; })
        );
        var totalDiscount = cart.total_discount || 0;
        discountRows.innerHTML = totalDiscount > 0
          ? '<div class="nk-cart-drawer__row nk-cart-drawer__row--discount"><span>Discount</span><span>−' + fmt(totalDiscount) + '</span></div>'
          : '';
      }

      var shipEl = document.querySelector('[data-nk-cart-shipping]');
      if (shipEl) {
        shipEl.textContent = cart.items.length === 0 ? '—' : (cart.total_price >= 59900 ? 'Free' : 'Calculated at checkout');
      }

      var totalEl = document.querySelector('[data-nk-cart-total]');
      if (totalEl) totalEl.textContent = fmt(cart.total_price);

      var savingWrap = document.querySelector('[data-nk-cart-saving]');
      if (savingWrap) {
        var saved = cart.total_discount || 0;
        savingWrap.hidden = saved <= 0;
        if (saved > 0) savingWrap.querySelector('[data-nk-cart-saving-amount]').textContent = fmt(saved);
      }

      renderOffers(cart);
    },
  };

  /* ---------------- offers banner (reads real cart contents) ---------------- */
  function renderOffers(cart) {
    var wrap = document.querySelector('[data-nk-offers]');
    if (!wrap) return;
    var modes = cart.items.map(function (i) { return (i.properties && i.properties._mode) || ''; });
    var count = cart.item_count;
    var hasAm = modes.some(function (m) { return m === 'am' || m === 'both'; });
    var hasPm = modes.some(function (m) { return m === 'pm' || m === 'both'; });
    var bundleOn = hasAm && hasPm;
    var stockOn = count >= 3;
    var shipOn = cart.total_price >= 59900;

    wrap.querySelectorAll('[data-offer]').forEach(function (card) {
      var key = card.getAttribute('data-offer');
      var on = key === 'bundle' ? bundleOn : key === 'stock' ? stockOn : key === 'ship' ? shipOn : false;
      card.classList.toggle('is-on', on);
      var state = card.querySelector('[data-offer-state]');
      if (state) {
        if (key === 'stock') {
          state.textContent = on ? 'Applied' : count + ' of 3 in cart';
        } else if (key === 'ship') {
          state.textContent = on ? 'Applied' : 'Spend ' + fmt(Math.max(0, 59900 - cart.total_price)) + ' more';
        } else {
          state.textContent = on ? 'Applied' : 'Add the other half';
        }
      }
    });
  }

  /* ---------------- newsletter (Shopify customer form, ajax-enhanced) ---------------- */
  function initNewsletter() {
    document.querySelectorAll('[data-nk-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        var msg = form.querySelector('[data-nk-newsletter-msg]');
        if (!input || !/.+@.+\..+/.test(input.value)) {
          e.preventDefault();
          if (msg) msg.textContent = 'Enter a valid email.';
          return;
        }
        if (msg) msg.textContent = 'You’re on the list.';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initProgress();
    initHero();
    initRitual();
    initPouchTilt();
    initVariantTabs();
    initFaq();
    initNewsletter();
    Cart.init();
  });
})();
